import { CanDeactivateFn } from "@angular/router";
import type { AdminCalibrationTalentMatrixComponent } from "./admin-calibration-talent-matrix.component";

/**
 * CanDeactivate guard per la matrice di Calibration (spec Monitoraggio §9.3).
 *
 * La matrice e' una simulazione che non si salva: uscendo (freccia indietro, logo o menu
 * dell'header) con almeno una persona spostata si apre la modale "Esci dalla matrice?" e si attende
 * la scelta. "Resta nella pagina" blocca la navigazione, "Esci dalla matrice" la consente.
 */
export const adminCalibrationTalentMatrixCanDeactivate: CanDeactivateFn<AdminCalibrationTalentMatrixComponent> =
  (component) => component.guardPendingChanges();
